import { auth } from '@/services/'

export const isAuthorized = async (path) => {
  let authorized = true

  if (path !== '/login') {
    const data = await auth.getUserAuthData()
    const tokenValidExpiry = ((data || {}).expiry >= (Date.now() / 1000))
    authorized = !!(data && tokenValidExpiry)
  }

  return authorized
}
